__turbopack_context__.v({
  "amount": "search-results-header-module-scss-module__2HO0BW__amount",
  "dropdown": "search-results-header-module-scss-module__2HO0BW__dropdown",
  "mobile-filters-button": "search-results-header-module-scss-module__2HO0BW__mobile-filters-button",
  "search-results-header": "search-results-header-module-scss-module__2HO0BW__search-results-header",
});
